<template>
	<div class="buttons vx-row mt-8">
		<vs-button
			v-if="userRole === 'admin'"
			class="mx-1 mt-2 edit-btn"
			@click="editAction"
		>
			{{ $t("edit") }}
		</vs-button>

		<vs-button
			v-if="userRole === 'admin'"
			:disabled="disabled"
			class="mx-1 mt-2 edit-btn"
			@click="changeBalance"
		>
			{{ $t("changeBalance") }}
		</vs-button>

		<vs-button
			v-if="userRole === 'admin'"
			:disabled="disabled"
			class="mx-1 mt-2 problem-btn"
			:class="[isProblem ? 'vs-button-danger' : 'vs-button-warning']"
			@click="setProblemState"
		>
			{{ isProblem ? $t("problemAuthor") : $t("markAsProblem") }}
		</vs-button>

		<vs-button
			v-if="userRole === 'admin'"
			class="mx-1 mt-2 vs-button-danger"
			@click="setPenaltyState"
		>
			{{ $t("penalty") }}
		</vs-button>
	</div>
</template>

<script>
export default {
	name: "ProfileActions",

	props: {
		disabled: {
			type: Boolean,
			default: false
		},

		isProblem: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		userRole() {
			return this.$store.state.auth.role;
		}
	},

	methods: {
		editAction() {
			this.$emit("edit-action");
		},

		changeBalance() {
			this.$emit("change-balance");
		},

		setProblemState() {
			this.$emit("set-problem-state");
		},

		setPenaltyState() {
			this.$emit("set-penalty-state");
		}
	}
};
</script>

<style lang="scss" scoped>
.buttons {
	.edit-btn {
		width: 100%;
		max-width: 200px;
	}

	.problem-btn {
		width: 100%;
		max-width: fit-content;
	}

	.vs-button {
		@media screen and (max-width: 500px) {
			max-width: 100%;
			width: 100%;
		}
	}
}
</style>
